module.exports = __webpack_public_path__ + "assets/media/3.3f5e5eac.wav";